import { colorPalette } from '../../colorPalette';
export const paymentSummaryWrapperStyles = () => ({
    transferSummaryWrapperContainer: {
        border: `${colorPalette.gray300} solid 0.5px`,
        borderRadius: '8px',
        maxWidth: '100%',
    },
    divider: {
        border: `1px solid ${colorPalette.gray200}`,
    },
    infoBox: {
        backgroundColor: colorPalette.lightBlue100,
        borderRadius: '8px',
        padding: '10px',
    },
    infoIcon: {
        position: 'relative',
        width: '16px',
        height: '16px',
        color: colorPalette.white,
        backgroundColor: colorPalette.lightBlue800,
        borderRadius: '50%',
    },
    infoText: {
        color: `${colorPalette.gray700}`,
        display: 'flex',
        flexDirection: 'column',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '18px',
        paddingLeft: '16px',
        overflow: 'inherit',
    },
    iconContainer: {
        display: 'flex',
        flexDirection: 'row',
        padding: '16px',
    },
    iconBorder: {
        border: `${colorPalette.gray100} solid 0.5px`,
        borderRadius: '8px',
        marginRight: '18px',
        padding: '9px',
        backgroundColor: colorPalette.gray100,
        color: colorPalette.gray900,
    },
    infoCard: {
        display: 'flex',
        alignItems: 'center'
    }
});
